/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDoor = createReactComponent("outline", "door", "IconDoor", [["path", { "d": "M14 12v.01", "key": "svg-0" }], ["path", { "d": "M3 21h18", "key": "svg-1" }], ["path", { "d": "M6 21v-16a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v16", "key": "svg-2" }]]);

export { IconDoor as default };
//# sourceMappingURL=IconDoor.mjs.map
